import { render } from "./DeletePackage.vue?vue&type=template&id=e49c3f30"
import script from "./DeletePackage.vue?vue&type=script&lang=js"
export * from "./DeletePackage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__